import Choices from 'choices.js';

// Ensure JS runs once the DOM is fully ready (works with or without Turbo)
document.addEventListener('turbo:load', initVariantSelector);
document.addEventListener('DOMContentLoaded', initVariantSelector);

function initVariantSelector () {
  const selector = document.getElementById('choices-single-remote-fetch');
  if (!selector) return;

  const { productId, redirectUri } = selector.dataset;

  // Fetch variants first so we can initialise Choices with a pre-selected option
  fetch(`/products/${productId}/variant_options?redirect_uri=${encodeURIComponent(redirectUri)}`)
    .then(res => res.json())
    .then(variants => {
      // Build data structure expected by Choices
      const choicesData = variants.map(v => ({
        label: v.text,
        value: v.value,
        selected: v.selected
      }));

      // Create the Choices instance
      const choicesInstance = new Choices(selector, {
        allowHTML: false,
        shouldSort: false,               // preserve order from server
        searchPlaceholderValue: 'Search or select an option',
        itemSelectText: 'Press to select',
        classNames: {
          flippedState: ''
        }
      });

      // Inject choices + ensure the current variant is selected
      choicesInstance.setChoices(choicesData, 'value', 'label', true);
      const preSelected = choicesData.find(c => c.selected);
      if (preSelected) {
        choicesInstance.setChoiceByValue(preSelected.value);
      }

      // When the dropdown opens, scroll to and highlight the selected choice for better UX
      selector.addEventListener('showDropdown', () => {
        const dropdown = choicesInstance.dropdown?.element;
        if (!dropdown) return;
        const selectedEl = dropdown.querySelector(`.choices__item--choice.is-selected[data-value="${CSS.escape(selector.value)}"]`);
        if (selectedEl) {
          // Make sure the element is visually highlighted
          if (typeof choicesInstance._highlightChoice === 'function') {
            choicesInstance._highlightChoice(selectedEl);
          } else {
            selectedEl.classList.add('is-highlighted');
          }
          selectedEl.scrollIntoView({ block: 'nearest' });
        }
      });

      // Redirect on change
      selector.addEventListener('change', e => {
        const value = (e.detail && e.detail.value) || selector.value;
        if (value) window.location.href = value;
      });
    })
    .catch(() => {
      // Graceful degradation – if the fetch fails, the native select will still work (fallback)
    });
}
